module.exports = __webpack_public_path__ + "img/i-refuse.a3e02163.svg";